import { STATIC_URL } from 'constants/data'

const imgPath = {
  email: `${STATIC_URL}/articles/email.png`,
}

const defaultSubText = {
  title: 'Оставайтесь в курсе событий вместе с Medpoint',
  subtitle: 'Присылаем лучшие статьи раз в неделю',
}

export { imgPath, defaultSubText }
